export default __webpack_public_path__ + "static/media/elipse-empty.f7b8ed68.svg";